import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { EqualContentsRow } from "../../../../../libraries/ReportGenerator/EqualContentsRow";
import { KeyValUnderline } from "../../../../../libraries/ReportGenerator/KeyValUnderline";
import ReportFraInfoSectionContainer from "../../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTitleSection from "../../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../../sims/style";
import { ReportGroupingUtils } from "../../../utils/reportGroupingUtils";
import AssetAreaCondition from "../../AssetAreaConditionReport";
import { ballastSchema, schema2, SEIII_TrackCircuitSchema } from "./SEIII_TrackCircuitSchema";

import React from "react";

const SEIII_TrackCircuitReport = (props) => {
  const { reportData } = props;
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "Path_SEIIITrackCircuitTest",
    "PATH_AssetAreaCondition",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};
const ViewReport = (props) => {
  const { data } = props;
  const { decodedData } = data;
  let tourfound = decodedData.find((e) => (e.otherInfo || {}).tours);
  let tours = tourfound && tourfound.otherInfo.tours;
  let tour = tours && tours[0];
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");
  let showReport = assetAreaConditionData.length !== decodedData.length;
  return (
    showReport && (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection {...props} fontSizeOverride={"35px"} />
        <span className="spacer"></span>
        <ReportFraInfoSectionContainer
          {...props}
          data={{ ...data, tourNumber: (tour && tour.name) || (tour && tour.description) || " " }}
        />
        <span className="spacer"></span>
        {/* <KeyValUnderline title="Track Circuit ID" value={decodedData[0].summary.assetId || ""} containerStyles={{}} titleStyles={{}} /> */}
        <AssetAreaCondition data={assetAreaConditionData} />
        {/* <KeyValUnderline title="Ballast Conditions" value={decodedData[0].summary.ballast || ""} containerStyles={{}} titleStyles={{}} /> */}
        {decodedData
          .filter((t) => t.testCode !== "PATH_AssetAreaCondition")
          .map((singleReport, index) => (
            <div key={index}>
              <span className="spacer"></span>
              <table className="table-bordered">
                {ballastSchema.map((section, key) => (
                  <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
                ))}
                {SEIII_TrackCircuitSchema.map((section, key) => (
                  <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
                ))}
              </table>
            </div>
          ))}
      </div>
    )
  );
};

export default SEIII_TrackCircuitReport;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/SEIII/index.jsx